export enum AppStatus {
  UserAlreadyExists = 'userAlreadyExists',
  ConfirmSignUpSuccess = 'confirmSignUpSuccess',
  ConfirmSignUpError = 'confirmSignUpError',
  ResetPasswordSuccess = 'resetPasswordSuccess',
  ResetPasswordError = 'resetPasswordError',
  ResetPasswordRequired = 'resetPasswordRequired'
}
